module.exports = __webpack_public_path__ + "img/shouye-juncaixinxi-png.8a59290b.svg";